import { getRealm, stateRealm } from '@infinitro/config';
import { statePlayerId } from './auth';
const DEBUG = false;
function log(msg) {
    if (DEBUG)
        console.log(msg);
}
let _realm = getRealm();
let _playerId = undefined;
let _prefix = _realm;
statePlayerId.subscribe((playerId) => {
    _playerId = playerId;
    if (playerId) {
        _prefix = playerId;
    }
    else {
        _prefix = _realm;
    }
});
stateRealm.subscribe((realm) => {
    _realm = realm;
    if (!_playerId) {
        _prefix = _realm;
    }
});
// store the key/value pair for optionally expires number of seconds
export const storeUserValue = (key, value, expires) => {
    if (typeof window === 'undefined' || typeof localStorage === 'undefined')
        return;
    key = `${_prefix}_${key}`;
    try {
        sessionStorage.setItem(key, JSON.stringify({
            value,
            expires: expires ? Math.floor(new Date().getTime() / 1000) + expires : null
        }));
        log(`sessionStorage[${key}] <- ${value}`);
    }
    catch (e) {
        console.log(`Error storing ${key} in session storage: ${e}`);
        //posthog.capture(`Error storing in session storage`, { key, error: e });
    }
    try {
        localStorage.setItem(key, JSON.stringify({
            value,
            expires: expires ? Math.floor(new Date().getTime() / 1000) + expires : null
        }));
        log(`localStorage[${key}] <- ${value}`);
    }
    catch (e) {
        console.log(`Error storing ${key} in local storage: ${e}`);
        //posthog.capture(`Error storing in local storage`, { key, error: e });
    }
};
export const getUserValue = (key) => {
    if (typeof window === 'undefined' || typeof localStorage === 'undefined')
        return undefined;
    key = `${_prefix}_${key}`;
    try {
        const str = sessionStorage.getItem(key);
        if (str) {
            const data = JSON.parse(str);
            if (!data.expires || (data.expires && new Date(data.expires * 1000) > new Date())) {
                log(`cookie[${key}] -> ${data.value}`);
                return data.value;
            }
        }
    }
    catch (e) {
        console.log(`Error getting ${key} from session storage: ${e}`);
        //posthog.capture(`Error getting from session storage`, { key, error: e });
    }
    try {
        const str = localStorage.getItem(key);
        if (str) {
            const data = JSON.parse(str);
            if (!data.expires || (data.expires && new Date(data.expires * 1000) > new Date())) {
                log(`localStorage[${key}] -> ${data.value}`);
                return data.value;
            }
        }
    }
    catch (e) {
        console.log(`Error getting ${key} from local storage: ${e}`);
        //posthog.capture(`Error getting from local storage`, { key, error: e });
    }
};
export const clearUserValue = (key) => {
    if (typeof window === 'undefined' || typeof localStorage === 'undefined')
        return;
    key = `${_prefix}_${key}`;
    try {
        sessionStorage.removeItem(key);
    }
    catch (e) {
        console.log(`Error removing ${key} from session storage: ${e}`);
        //posthog.capture(`Error removing from session storage`, { key, error: e });
    }
    try {
        localStorage.removeItem(key);
    }
    catch (e) {
        console.log(`Error removing ${key} from local storage: ${e}`);
        //posthog.capture(`Error removing from local storage`, { key, error: e });
    }
};
